<div class="modal-header">
    <h5 class="modal-title">Release Note</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="d-flex flex-column gap-3 modal-body">
    <p class="mb-0">A new release note is available. Below you'll find a brief summary of what's included. Click <b>"View More"</b> to open the full release note in a new tab. Click <b>"Acknowledge"</b> to stop seeing this message.</p>
    <div class="card border border-1 rounded mb-3 d-flex flex-column gap-3 p-3">
        <div class="d-flex justify-content-between">
            <span class="text-primary">
                <b>{{ releaseNote.title }}</b>
            </span>
            <span class="">
                {{ releaseNote.date | date: 'dd/MM/yyyy' }}
            </span>
        </div>
        <div [innerHTML]="releaseNote.description"></div>
    </div>
</div>
<div class="modal-footer">
    <a sfButton [href]="releaseNote.url" target="_blank">View more</a>
    <a sfButton ngbAutofocus (click)="ackowledge()">Acknowledge</a>
</div>
